export const fetchConnectedWallet = async (address: string) => {
  try {
    const response = await fetch(`/api/connect-wallet?address=${address}`, {
      method: "GET",
      cache: "no-cache",
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.log("Error in fetching connected wallet details:", error);
    return error;
  }
};

export interface ConnectWalletRequest {
  address: string;
  signature: string;
}

export const connectWallet = async (walletDetails: ConnectWalletRequest) => {
  try {
    const response = await fetch("/api/connect-wallet", {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(walletDetails),
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.log("Error in connect wallet:", error);
    return error;
  }
};
